import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

import PostCard from './PostCard';

const CommunityFeed = ({ posts, currentUserId, onRefresh }) => {
  const [filterCategory, setFilterCategory] = useState('all');
  const [sortBy, setSortBy] = useState('recent');

  const categories = [
    { value: 'all', label: 'All Posts', icon: 'Grid' },
    { value: 'achievement', label: 'Achievements', icon: 'Trophy' },
    { value: 'question', label: 'Questions', icon: 'HelpCircle' },
    { value: 'challenge', label: 'Challenges', icon: 'Target' },
    { value: 'motivation', label: 'Motivation', icon: 'Zap' },
    { value: 'event', label: 'Events', icon: 'Calendar' },
    { value: 'general', label: 'General', icon: 'MessageSquare' }
  ];

  const filteredPosts = posts
    ?.filter(post => filterCategory === 'all' || post?.category === filterCategory)
    ?.sort((a, b) => {
      if (sortBy === 'recent') {
        return new Date(b?.created_at) - new Date(a?.created_at);
      } else if (sortBy === 'popular') {
        return b?.likes_count - a?.likes_count;
      } else if (sortBy === 'discussed') {
        return b?.comments_count - a?.comments_count;
      }
      return 0;
    });

  const pinnedPosts = filteredPosts?.filter(post => post?.is_pinned);
  const regularPosts = filteredPosts?.filter(post => !post?.is_pinned);

  return (
    <div className="space-y-6">
      {/* Filters */}
      <div className="bg-card rounded-xl p-4 shadow-md border border-border">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Category Filter */}
          <div className="flex items-center gap-2 overflow-x-auto pb-2 md:pb-0">
            {categories?.map((category) => (
              <button
                key={category?.value}
                onClick={() => setFilterCategory(category?.value)}
                className={`
                  flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors
                  ${filterCategory === category?.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-foreground hover:bg-muted/80'
                  }
                `}
              >
                <Icon name={category?.icon} size={16} />
                {category?.label}
              </button>
            ))}
          </div>

          {/* Sort */}
          <div className="flex items-center gap-2">
            <Icon name="ArrowUpDown" size={16} color="var(--color-muted-foreground)" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e?.target?.value)}
              className="px-3 py-2 bg-background border border-border rounded-lg text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option value="recent">Most Recent</option>
              <option value="popular">Most Popular</option>
              <option value="discussed">Most Discussed</option>
            </select>
          </div>
        </div>
      </div>
      {/* Pinned Posts */}
      {pinnedPosts?.length > 0 && (
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Icon name="Pin" size={20} color="var(--color-primary)" />
            <h3 className="text-lg font-semibold text-foreground">Pinned Posts</h3>
          </div>
          {pinnedPosts?.map((post) => (
            <PostCard
              key={post?.id}
              post={post}
              currentUserId={currentUserId}
              onRefresh={onRefresh}
              isPinned
            />
          ))}
        </div>
      )}
      {/* Regular Posts */}
      <div className="space-y-4">
        {regularPosts?.length === 0 ? (
          <div className="bg-card rounded-xl p-12 shadow-md border border-border text-center">
            <Icon name="Users" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-foreground mb-2">
              No Posts Yet
            </h3>
            <p className="text-sm text-muted-foreground max-w-md mx-auto">
              Be the first to share something with your gym community! Click "New Post" to get started.
            </p>
          </div>
        ) : (
          regularPosts?.map((post) => (
            <PostCard
              key={post?.id}
              post={post}
              currentUserId={currentUserId}
              onRefresh={onRefresh}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default CommunityFeed;